// Real reels from Andrew (02.11.2026). Tracking params removed — always use clean URLs.
// Account behind every reel: @ai_psyhelp "AI PSY HELP | Wellbeing App".

const IG = (code) => `https://www.instagram.com/reel/${code}/`;

export const LUMI_INSTAGRAM_PROFILE = {
  uk: 'https://www.instagram.com/ai_psyhelp/',
  en: 'https://www.instagram.com/ai_psyhelp/',
  de: 'https://www.instagram.com/ai_psyhelp/',
  lt: 'https://www.instagram.com/ai_psyhelp/'
};

const EN_SET = [
  { id: 'big-day', code: 'DfNeIYGDdGI', cover: '/assets/lumi/stories/en-big-day.webp' },
  { id: 'halloween-night', code: 'DfKv48zj2DT', cover: '/assets/lumi/stories/en-halloween-night.webp' },
  { id: 'message-journey', code: 'DfFwNrajGoS', cover: '/assets/lumi/stories/all-message-journey.webp' },
  { id: 'happy-for-them', code: 'DfFMzg5ksSW', cover: '/assets/lumi/stories/en-happy-for-them.webp' }
];

export const LUMI_STORIES = {
  uk: [
    { id: 'night-kitchen', code: 'DfKUUhAgkdG', cover: '/assets/lumi/stories/uk-night-kitchen.webp' },
    { id: 'halloween-night', code: 'DfKvuSjgkgI', cover: '/assets/lumi/stories/uk-halloween-night.webp' },
    { id: 'brave-word', code: 'DfO3GwTAmI7', cover: '/assets/lumi/stories/uk-brave-word.webp' },
    { id: 'inbox-closeness', code: 'DeXlD1AjRYH', cover: '/assets/lumi/stories/uk-inbox-closeness.webp' }
  ],
  en: EN_SET,
  lt: EN_SET,
  de: [
    { id: 'brave-word', code: 'DfO3V2hDlHZ', cover: '/assets/lumi/stories/de-brave-word.webp' },
    { id: 'big-day', code: 'DfNeOUGD2LM', cover: '/assets/lumi/stories/de-big-day.webp' },
    { id: 'halloween-night', code: 'DfKwBKPDDn2', cover: '/assets/lumi/stories/de-halloween-night.webp' },
    { id: 'message-journey', code: 'DfFwNrajGoS', cover: '/assets/lumi/stories/all-message-journey.webp' }
  ]
};

export const storyUrl = (item) => IG(item.code);

export function storiesFor(language) {
  const lng = String(language || 'en').split('-')[0];
  return LUMI_STORIES[lng] || LUMI_STORIES.en;
}

export const LUMI_YOUTUBE = 'https://www.youtube.com/@AIPSYHELP';
